module.exports = __webpack_public_path__ + "static/img/info.157aeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/info.png
// module id = 1ADd
// module chunks = 1